import axios from "../api";
/**
 * Removes the given physical club cards (EA item ids) from the user's imported
 * club. Quietly: the backend would otherwise notify the user for every card.
 */
export const deleteSpecificUserPlayers = async (eaPlayerIds) => {
    await axios.delete(`/user-players?ids=${eaPlayerIds.join(",")}&notify=false`);
};
//# sourceMappingURL=deleteSpecificUserPlayers.js.map